module.exports = __webpack_public_path__ + "img/japan-mental-and-behavioural-disorders-male.76460f03.png";